export const mapExpenseReportListToCsvExport = (data: any[]) => {
    return data.map((item) => ({
        'Supplier ID': item.id,
        'Supplier Name': item.name,
        'Contact Email': item.email,
    }));
};
